import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

/**
 * Comment moderation (MD-5576) is rolled out brand by brand behind the
 * `comment-moderation` PostHog flag: the sidebar entry and the route both
 * read this, so nav and route agree. The flag only decides visibility; the
 * daily job runs for a brand only once it is enabled in the page's settings.
 */
export default function useCommentModerationAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(
    POSTHOG_FEATURES.COMMENT_MODERATION,
  )

  return { hasAccess: isFeatureFlagEnabled }
}
